<template>
    <div class="left" id="cisViewPort">
        <LoadingSpinner v-if="loadIndicatorVisible" />
        <div class="descript">
            <div class="head">
                {{caption.HeaderText}}
            </div>
            <div class="subhead-top">
                {{caption.DecText}}
            </div>       
            <div class="subhead">
                {{caption.DecText2}}
            </div>
            <div class="drp-main">
                <div class="drp-down">

                    <p>
                        {{caption.PlsChoose}}
                    </p>
                    <p>
                        <DxSelectBox v-model="tty" :dataSource="topicTypeList" displayExpr="TtyName"></DxSelectBox>
                    </p>
          
                    <p class="btn">
                        <DxButton :text="btn.BtnCreatNewTheme"
                                  :type="saveButtonType"
                                  :disabled="createTopicDisabled"
                                  styling-mode="contained"
                                  @click="createNewTopic()" />
                    </p>
                  
                </div>

            </div>
             


            <!--<div class="background">

                <img class="themeNeuanlegen" v-bind:src="themeNeuanlegen" />
            </div>-->
        </div>

     
    </div>
</template>

<script>
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxButton } from 'devextreme-vue/button';
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import $ from 'jquery'
    export default {
        name: 'ModulRegionDetail',
        components: {
            DxSelectBox, LoadingSpinner, DxButton
        },
        data() {
            return {
                themeNeuanlegen: "~/Images/hintergrundThemeNeueAnlegen2.svg",
                tty: null,
                caption: {
                    DecText: this.$LanguageProvider.GetResource("CreateNewTopicDesc_1", "Caption", "Teilen Sie uns mit, welche Themen Sie im Zusammenhang mit der Arbeitswelt von Morgen bewegen! Damit erweitern Sie das inhaltliche Repertoire unserer gemeinsamen Plattform um weitere Aspekte und Quellen. Hier eingereichte Vorschläge werden von dem Redaktionsteam aufgegriffen und im weiteren Diskurs bzw.Scanning-Prozess berücksichtigt:"),
                    DecText2: this.$LanguageProvider.GetResource("CreateNewTopicDesc_2", "Caption", ""),
                    YourSuggestion: this.$LanguageProvider.GetResource("YourSuggestion", "title", "Your topic"),
                    PlsChoose: this.$LanguageProvider.GetResource("PlsChoose", "title", "Please choose a topic type:"),
                    HeaderText: this.$LanguageProvider.GetResource("HeaderText", "title", "Create New Topics"),
                },
                btn: {
                    BtnCreatNewTheme: this.$LanguageProvider.GetResource("BtnCreatNewTheme", "title", "Neues Thema erstellen")

                },
                popupVisible: true,
                loadIndicatorVisible: false,
                closeButtonOptions: {
                    text: this.$LanguageProvider.GetResource("BtnCancel", "title", "Abbrechen"),
                    type: 'danger',
                    onClick: () => {
                        $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                    }
                },
                createTopic: {
                    text: this.$LanguageProvider.GetResource("BtnContinue", "title", "Weiter"),
                    type: 'success',
                    onClick: () => {
                        this.loadIndicatorVisible = true
                        //this.popupVisible = false
                        $("form").attr("action", window.location.pathname + "?action=create&ttyId=" + this.tty.TtyId).submit();
                    }
                },
            };
        },

        computed: {
            topicTypeList() {
                return this.$store.state.createTopicStore.topicTypeList
            },
            createTopicDisabled() {
                return this.tty == null || this.tty == {}
            },

        },
        created: function () {
            this.$store.dispatch("getTopicTypesForCreation")
        },
        methods: {
            createNewTopic() {
                this.loadIndicatorVisible = true
                $("form").attr("action", window.location.pathname + "?action=create&ttyId=" + this.tty.TtyId).submit();
            }
        }
    }


</script>
<style scoped>

    .head {
        margin-left: 80px;
    }
    .drp-down {
        width: fit-content;
        margin: auto;
        margin-top: 145px;
        background-color: white;
        padding: 10px;
    }
    .drp-main {
        background-image: url("~/Images/hintergrundThemeNeueAnlegen2.svg");
        height: 400px;
        background-size: cover;
        margin-left: 60px;
        display: grid;

    }


    .subhead-top {
        font-size: var(--page-description-text-size);
        margin-left: 80px;
           max-width: 700px;
           padding-bottom:5px;
    }

    .descript {
        padding-left: 20px;
        max-width: 1000px;
    }
    .btn {
        padding-top: 10px;
        text-align: -webkit-center;
    }
    .subhead {
        padding-bottom: 20px;
        font-size: var(--page-description-text-size);
        max-width: 700px;
        margin-left: 80px;
    }

    .background {
        width: 1000px;
        margin-left: -44px;
        margin-top: 50px;
    }
</style>
